function escapeHtml(value) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
}

export function buildProjectOverviewHtml(project, files) {
  const names = files.map((file) => file.path || file).filter(Boolean)
  const title = `Project ${project?.project_id || ''}`.trim()
  const compactFileCount = Number(project?.files_count) || 0
  const items = names.length
    ? names.map((name) => `<li>${escapeHtml(name)}</li>`).join('')
    : `<li>${escapeHtml(`${compactFileCount || 'Generated'} files are packaged in the source ZIP`)}</li>`
  const description = compactFileCount && !names.length
    ? `The source package is ready with ${compactFileCount} files. Download the ZIP to inspect or run the generated project.`
    : 'The source package is ready. Download the ZIP to inspect or run the generated files.'
  return `<!doctype html>
<html lang="en">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1" />
<style>
body{margin:0;font-family:Inter,system-ui,sans-serif;background:#f7f4ef;color:#2d2823}
main{max-width:880px;margin:0 auto;padding:48px 28px}
.card{background:white;border:1px solid #e5ded5;border-radius:18px;padding:28px;box-shadow:0 18px 60px #2d282314}
h1{margin:0 0 8px;font-size:30px}p{color:#766b60;line-height:1.55}
ul{columns:2;gap:32px;padding-left:20px}li{break-inside:avoid;margin:8px 0;font-family:ui-monospace,monospace}
</style>
</head>
<body><main><section class="card"><h1>${escapeHtml(title)}</h1>
<p>${escapeHtml(description)}</p>
<ul>${items}</ul></section></main></body></html>`
}
